/**
 * モバイルのサイズを取得する
 */
export const is_Mobile = () => {
    if(767 >= window.innerWidth) {
        return "sp";
    } else if(1020 >= window.innerWidth) {
        return "tab";
    } else {
        return "pc"
    }
}

/**
 * remをpxに変換する
 */
export const remToPx = (rem) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}


// debounce関数を定義
export const debounce = (func, wait) => {
    let timeout;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
}

// タイトルを隣り合う要素と同じ高さにする
export const ElementHeightSize = (cN, ElementNum) => {
    const classN = cN;
    let maxHeight = 0;
    const TtlNum = ElementNum;
    const elementTitles = document.querySelectorAll(`.${classN}`)
    if (elementTitles) {
        elementTitles.forEach((itemTtl, index) => {
            if(0 == (index % TtlNum)) {
                maxHeight = maxElementsHeight(classN, index, index + TtlNum);
                maxElementsHeightSize(classN, maxHeight, index, index + TtlNum);
            }
        });
    }
}
// タイトルを隣り合う要素と同じ高さにする -pc -tab
export const ElementHeightSizePcTab = (cN, ElementNum) => {
    const classN = cN;
    let maxHeight = 0;
    const pcTtlNum = ElementNum;
    const elementTitles = document.querySelectorAll(`.${classN}`)
    if (elementTitles) {
        elementTitles.forEach((itemTtl, index) => {
            if(is_Mobile() == "pc" || is_Mobile() == "tab") {
                if(0 == (index % pcTtlNum)) {
                    maxHeight = maxElementsHeight(classN, index, index + pcTtlNum);
                    maxElementsHeightSize(classN, maxHeight, index, index + pcTtlNum);
                }
            } else {
                itemTtl.style.height = 'auto';
            }
        });
    }
}
// 隣り合う要素と同じ高さにする -sp
const ElementHeightSizeSp = (cN, ElementNum) => {
    const classN = cN;
    let maxHeight = 0;
    const spTtlNum = ElementNum;
    const elementTitles = document.querySelectorAll(`.${classN}`)
    if (elementTitles) {
        elementTitles.forEach((itemTtl, index) => {
            if(is_Mobile() == "sp") {
                if(0 == (index % spTtlNum)) {
                    maxHeight = maxElementsHeight(classN, index, index + spTtlNum);
                    maxElementsHeightSize(classN, maxHeight, index, index + spTtlNum);
                }
            } else {
                itemTtl.style.height = 'auto';
            }
        });
    }
}

// 要素の縦幅最大サイズを取得
export const maxElementsHeight = (classN, start, end) => {
    const elements = document.querySelectorAll(`.${classN}`);
    let maxHeight = 0;
    elements.forEach((element, index) => {
        if ((index >= start && index < end) && element.offsetHeight > maxHeight) {
            maxHeight = element.offsetHeight;
        }
    });
    return maxHeight;
}

// 取得した要素の縦幅をそれぞれ合わせる
export const maxElementsHeightSize = (classN, maxHeight, start, end) => {
    const elements = document.querySelectorAll(`.${classN}`);
    elements.forEach((element, index) => {
        if(index >= start && index < end) {
            element.style.height = `${maxHeight}px`;
        }
    });
}

// 高さを全てautoにする
export const allElementHeightAuto = (elementsClass) => {
    const elements = document.querySelectorAll(`.${elementsClass}`);
    if (elements) {
        elements.forEach((element) => {
            element.style.height = 'auto';
        });
    }
}

// 高さを全てautoにした後それぞれの要素の縦幅を合わせる
export const elementSizeModify = (elementName, ColumnNum) => {
    allElementHeightAuto(elementName);
    ElementHeightSize(elementName, ColumnNum);
}
// 高さを全てautoにした後それぞれの要素の縦幅を合わせる
export const elementSizeModifyPcTab = (elementName, ColumnNum) => {
    allElementHeightAuto(elementName);
    ElementHeightSizePcTab(elementName, ColumnNum);
}

// 高さを全てautoにした後それぞれの要素の縦幅を合わせる
export const elementSizeModifySp = (elementName, ColumnNum) => {
    allElementHeightAuto(elementName);
    ElementHeightSizeSp(elementName, ColumnNum);
}

/**
 * display:none;の切り替えが効いているところの高さ揃え：PC・SP 判定に応じて自動で調整
 *
 * @param {string} targetClass - 高さ揃え対象のクラス
 * @param {Object} options
 * @param {string} options.containerSelector - 対象を囲む親セレクタ
 * @param {number} options.columnPc - PC用のカラム数
 * @param {number} options.columnSp - SP用のカラム数
 */
export const observeAutoHeight = (targetClass, {
    containerSelector,
    columnPc,
    columnSp
}) => {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const adjustHeight = () => {
        const device = is_Mobile();
        if (device === "pc" || device === "tab") {
            elementSizeModifyPcTab(targetClass, columnPc);
        } else {
            elementSizeModifySp(targetClass, columnSp);
        }
    };

    let timer = null;
    const debouncedAdjust = () => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(adjustHeight, 150);
    };

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                debouncedAdjust();
                break;
            }
        }
    });

    observer.observe(container, {
        childList: true,
        subtree: true,
    });

    window.addEventListener('resize', debouncedAdjust);

    // 初回実行
    setTimeout(adjustHeight, 300);
};
